import { Button, Center, Group, Loader, Table, Text, useMantineTheme } from "@mantine/core";
import { IconPencil } from "@tabler/icons-react";
import React from "react";
import { Link } from "react-router-dom";
import { routes } from "@/configs/router.config/routes";
import { useWorkspaces } from "@/hooks/useWorkspaces";

const WorkspaceListPage: React.FC = () => {
  const theme = useMantineTheme();
  const { workspaces, isLoading } = useWorkspaces();

  const rows = workspaces?.map((workspace, i) => (
    <Table.Tr key={workspace.id}>
      <Table.Td>{i + 1}</Table.Td>
      <Table.Td>{workspace.name}</Table.Td>
      <Table.Td>{workspace.categoryMaxLevel - 1}</Table.Td>
      <Table.Td w={120}>
        <Group gap={10}>
          <Link to={routes.workspaceEdit(workspace.id)} style={{ textDecoration: "none" }}>
            <Group gap={0}>
              <IconPencil size={16} color={theme.colors.blue[5]} />
              <Text c={theme.colors.blue[5]} size="sm">編集</Text>
            </Group>
          </Link>
        </Group>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <Group justify="space-between">
        <h1>一覧</h1>
        <Link to={routes.workspaceCreate}>
          <Button>ワークスペースの追加</Button>
        </Link>
      </Group>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>#</Table.Th>
            <Table.Th>ワークスペース名</Table.Th>
            <Table.Th>カテゴリ階層数</Table.Th>
            <Table.Th />
          </Table.Tr>
        </Table.Thead>
        {!isLoading && <Table.Tbody>{rows}</Table.Tbody>}
      </Table>
      {isLoading && (
        <Center h={100}>
          <Loader color="gray" size="sm" data-testid="loader" />
        </Center>
      )}
    </>
  );
};

export default WorkspaceListPage;
